import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import PageReadNext from '../components/page-read-next';

interface PageReadNextProcessorElement extends Element {
  props: Element['props'] & {
    slot?: string;
    'data-erom-menu-slot'?: string;
    'data-section-title'?: string;
    'data-show-creation-date'?: string | boolean;
    'data-show-reading-time'?: string | boolean;
    sectionTitle?: string;
    showCreationDate?: boolean;
    showReadingTime?: boolean;
  };
}

const pageReadNext: Processor<PageReadNextProcessorElement> = {
  priority: 10,
  name: 'pageReadNext',
  test: ({ node }) => !!node.props?.className?.includes('wp-block-erom-page-read-next'),
  processor: ({ node }) => {
    node.props.sectionTitle = node.props['data-section-title'];

    const showCreationDate = node.props['data-show-creation-date'];
    const showReadingTime = node.props['data-show-reading-time'];

    node.props.showCreationDate = showCreationDate === 'true' || showCreationDate === true;
    node.props.showReadingTime = showReadingTime === 'true' || showReadingTime === true;

    node.component = PageReadNext as ComponentType;

    return node;
  }
};

export default pageReadNext;
